export default Backbone.Model.extend({
    url: '/notes/add_reply.json'
}, {
    type: 'noteReply'
});
